import React, { useEffect, useState } from 'react';
import {
    AppBar, Toolbar, Typography, IconButton, Button, Box,
    List, ListItemButton, FormGroup, FormControlLabel, Checkbox, Grid,
} from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import BooksService from "../../Services/Books";
import AuthorsService from "../../Services/Authors";
import ArticleService from "../../Services/Articles";
import i18n from '../../i18n';
import { useTranslation } from 'react-i18next';

const APP_BAR_HEIGHT = '90px';
const ACTION_BUTTONS_HEIGHT = '52px';
const BROWN_FOOTER_HEIGHT = '35px';

const baseTheme = createTheme({
    palette: {
        primary: { main: '#f97316' },
        secondary: { main: '#818589' },
    },
    typography: {
        h6: { color: '#fff', fontSize: '1rem' },
        body1: { fontSize: '0.875rem' },
    },
    components: {
        MuiListItemButton: {
            styleOverrides: {
                root: {
                    paddingY: '12px',
                    '&.Mui-selected': { backgroundColor: 'white' },
                    '&.Mui-selected:hover': { backgroundColor: 'white' },
                    '&:focus-visible': { outline: 'none' },
                    '&.Mui-selected:focus-visible': { outline: 'none' },
                },
            },
        },
        MuiFormControlLabel: {
            styleOverrides: {
                label: { fontSize: '0.875rem' },
                root: {
                    display: 'flex',
                    alignItems: 'center',
                    marginRight: 0,
                    marginLeft: 0,
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    fontSize: '0.75rem',
                    padding: '3px 6px',
                    color: 'white',
                },
            },
        },
    },
});

const MobileBooksFilterPage = () => {
 const { t } = useTranslation();
 const location: any = useLocation();
  const [selectedFilter, setSelectedFilter] = useState<string>(
    location?.state?.allArticles ? 'Category' : 'Language'
);
    const [selectedLanguage, setSelectedLanguage] = useState<string | null>(null);
    const [selectedAuthor, setSelectedAuthor] = useState<string | null>(null);
    const [selectedCategory, setSelectedCategory] = useState<string | null>(null);
    const [authors, setAuthors] = useState<any[]>([]);
    const [categories, setCategories] = useState<any[]>([]);
    const [languages, setLanguages] = useState<any[]>([]);
    const [selectedAuthorId, setSelectedAuthorId] = useState<any>();
    const [selectedLanguageId, setSelectedLanguageId] = useState<any>();
    const [selectedCategoryId, setSelectedCategoryId] = useState<any>();

    const [searchParams] = useSearchParams()
    // const isAllArticles = location?.state?.allArticles || searchParams.get("allArticles") === "true";


    const isAllArticles = !!location?.state?.allArticles
    const navigate = useNavigate();

    // Determine if any filter is selected to enable/disable buttons
    const isFilterSelected = selectedLanguage !== null || selectedAuthor !== null || selectedCategory !== null;
    useEffect(() => {
     if (isAllArticles && selectedFilter === 'Language') {
         setSelectedFilter('Category');
     }
    }, [isAllArticles, selectedFilter]);
    const handleLanguageChange = (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
        setSelectedLanguage(checked ? event.target.value : null);
        setSelectedLanguageId(checked ? languages.find(lang => lang.name === event.target.value)?.id : null);
    };

    const handleAuthorChange = (event: React.ChangeEvent<HTMLInputElement>, checked: boolean, author: any) => {
        setSelectedAuthor(checked ? event.target.value : null);
        setSelectedAuthorId(checked ? author?.id : null);
    };

    const handleCategoryChange = (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
        setSelectedCategory(checked ? event.target.value : null);
        setSelectedCategoryId(checked ? categories.find(cat => cat.name === event.target.value)?.id : null);
    };

    const handleReset = () => {
        setSelectedLanguage(null);
        setSelectedAuthor(null);
        setSelectedCategory(null);
        setSelectedAuthorId(null);
        setSelectedLanguageId(null);
        setSelectedCategoryId(null);
        console.log('Filters Reset');
    };

    const handleApply = () => {
        // debugger;
        navigate("/books", {
            state: {
                selectedAuthorId,
                authorName: selectedAuthor,
                selectedLanguageId,
                languageName: selectedLanguage,
                selectedCategoryId,
                categoryName: selectedCategory
            }
        });
    }

    useEffect(() => {
        if (isAllArticles) return
        else {
            BooksService.getFilters("book").then((res: any) => {
                if (res.status && res.result) {
                    setLanguages(res.result.languages);
                    setAuthors(res.result.authors);
                    setCategories(res.result.categories);
                } else {
                    console.warn("No filter data found or API status is not true.");
                }
            }).catch((error: any) => {
                console.error("Error fetching filters:", error);
            });
        }
    }, [i18n.language]);
  

    // useEffect(()=>{
    //  if(isAllArticles){
    //     ArticleService.getFilters("article").then((res:any)=>{
    //         if(res.status && res.result){

    //              console.log(res,"res==========aaaaaaaa")
    //             setLanguages(res.result.languages);
    //                setAuthors(res.result.authors);
    //                 setCategories(res.result.categories.map((item:any)=>item.name));

    //         } else{
    //             console.warn("No filter data found or API status is not true.");
    //         }
    //     }).catch((error:any)=>{
    //         console.error("Error fetching filters",error);
    //     })
    //  }
    // },[isAllArticles])


//     useEffect(() => {
//   const fetchFilters = async () => {
//     if (!isAllArticles) {
//       return;
//     }

//     try {
//       const res = await ArticleService.getFilters("article");
//       if (res.status && res.result) {
//         console.log("aaasdfasdfsvvv",res.result);
//         setAuthors(res.result.authors);
//         setCategories(res.result.categories);
//       } else {
//         console.warn("No filter data found or API status is not true.");
//       }
//     } catch (error) {
//       console.error("Error fetching filters", error);
//     }
//   };

//   fetchFilters();
// }, [isAllArticles]);

    //     useEffect(()=>{
    //  if(isAllArticles){
    //             AuthorsService.getAuthorData(3,"").then((res: any) => {
    //                 if (res.status && res.result) {
    //                     setLanguages(res.result.languages);
    //                     setAuthors(res.result.authors);
    //                     setCategories(res.result.categories);
    //                 } else {
    //                     console.warn("No filter data found or API status is not true.");
    //                 }
    //             }).catch((error: any) => {
    //                 console.error("Error fetching filters:", error);
    //             });

    //     },[isAllArticles])

    useEffect(() => {
        if (isAllArticles) {
            AuthorsService.getAuthorData(3, 50).then((res: any) => {
                // debugger;
                if (res.status && res.result) {

                    console.log(res.result, "abcreqqqqqq")
                    // setLanguages(res.result.languages);
                    setAuthors(res.result);
                    // setCategories(res.result.categories);
                }
                else {
                    console.warn("No filter data found or API status is not true.");
                }
            }).catch((error: any) => {
                console.error("Error fetching filters:", error);
            })
        }
    }, [isAllArticles])

     useEffect(() => {
        if (isAllArticles) {
            ArticleService.getarticlesCategory().then((res: any) => {
                // debugger;
                if (res.status && res.result) {

                    console.log(res.result, "abcreqqqqqq")
                    // setLanguages(res.result.languages);
                    setCategories(res.result);
                    // setCategories(res.result.categories);
                }
                else {
                    console.warn("No filter data found or API status is not true.");
                }
            }).catch((error: any) => {
                console.error("Error fetching filters:", error);
            })
        }
    }, [isAllArticles])

    return (
        <ThemeProvider theme={baseTheme}>
            <CssBaseline />
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100vh',
                    overflow: 'hidden',
                }}
            >
                <AppBar position="fixed" color="primary" elevation={0} sx={{ zIndex: 1100, height: APP_BAR_HEIGHT }}>
                    <Toolbar sx={{ position: 'relative', flexDirection: 'column', py: 0.5 }}>
                        <Typography variant="caption" sx={{ color: "#ffffffdd", opacity: 0.9 }}>
                            {t("shrihari_tr")}
                        </Typography>
                        <Box sx={{ position: 'relative', width: '100%', display: 'flex', alignItems: 'center' }}>
                            <IconButton size="large" edge="start" color="inherit" aria-label="back"
                                sx={{ position: 'absolute', left: 0, p: 0 }} onClick={() => navigate(-1)}>
                                <ArrowBackIosIcon style={{ height: 18, width: 18, color: "white" }} />
                            </IconButton>
                            <IconButton color="inherit" aria-label="home"
                                sx={{ position: 'absolute', left: 32, p: 0 }} onClick={() => navigate("/")}>
                                <HomeOutlinedIcon sx={{ color: "white", fontSize: '24px' }} />
                            </IconButton>
                            <Typography variant="h6" component="div" sx={{ flexGrow: 1, textAlign: 'center', fontSize: 15 }}>
                                Filter
                            </Typography>
                        </Box>
                    </Toolbar>
                </AppBar>

                <Box
                    sx={{
                        display: 'flex',
                        flexGrow: 1,
                        marginTop: APP_BAR_HEIGHT,
                        marginBottom: `calc(${ACTION_BUTTONS_HEIGHT} + ${BROWN_FOOTER_HEIGHT})`,
                        overflow: 'hidden',
                    }}
                >
                    <Grid item xs={5}
                        sx={{
                            backgroundColor: '#E0E0E0',
                            height: '100%',
                            overflowY: 'hidden',
                            flexShrink: 0,
                        }}
                    >
                        <List sx={{ marginTop: '-8px' }}>
                            {/* {['Language', 'Category', 'Author'].map((filterName) => (
                                <ListItemButton
                                    key={filterName}
                                    selected={selectedFilter === filterName}
                                    onClick={() => setSelectedFilter(filterName)}
                                >
                                    <Typography sx={{ color: selectedFilter === filterName ? '#f97316' : 'inherit' }}>
                                        {filterName}
                                    </Typography>
                                </ListItemButton>
                            ))} */}
                            {(isAllArticles ? ['Category', 'Author'] : ['Language', 'Category', 'Author']).map((filterName) => (
                            <ListItemButton
                                key={filterName}
                                selected={selectedFilter === filterName}
                                onClick={() => setSelectedFilter(filterName)}
                            >
                                <Typography sx={{ color: selectedFilter === filterName ? '#f97316' : 'inherit' }}>
                                    {filterName}
                                </Typography>
                            </ListItemButton>
                          ))}
                        </List>
                    </Grid>
                    <Grid item xs={7}
                        sx={{
                            py: 1,
                            px: 2,
                            backgroundColor: 'white',
                            height: '100%',
                            overflowY: 'auto',
                            msOverflowStyle: "none",
                            scrollbarWidth: "none",
                            flexGrow: 1,
                        }}
                    >
                        {selectedFilter === 'Language' && (
                            <FormGroup>
                                {languages.length > 0 ? (
                                    languages.map((language) => (
                                        <FormControlLabel
                                            key={language.id}
                                            value={language.name}
                                            control={
                                                <Checkbox
                                                    checked={selectedLanguage === language.name}
                                                    onChange={handleLanguageChange}
                                                    size="small"
                                                />
                                            }
                                            label={language.name}
                                        />
                                    ))
                                ) : (
                                    <Typography variant="body1">No languages available.</Typography>
                                )}
                            </FormGroup>
                        )}
                        {selectedFilter === 'Category' && (
                            <FormGroup>
                                {categories.length > 0 ? (
                                    categories.map((category) => (
                                        <FormControlLabel
                                            key={category.id}
                                            value={category.name}
                                            control={
                                                <Checkbox
                                                    checked={selectedCategory === category.name}
                                                    onChange={handleCategoryChange}
                                                    size="small"
                                                />
                                            }
                                            label={category.name}
                                        />
                                    ))
                                ) : (
                                    <Typography variant="body1">No categories available.</Typography>
                                )}
                            </FormGroup>
                        )}
                        {selectedFilter === 'Author' && (
                            <FormGroup>
                                {authors.length > 0 ? (
                                    authors.map((author) => (
                                        <FormControlLabel
                                            key={author.id}
                                            value={author.name}
                                            control={
                                                <Checkbox
                                                    checked={selectedAuthor === author.name}
                                                    onChange={(event, checked) => handleAuthorChange(event, checked, author)}
                                                    size="small"
                                                />
                                            }
                                            label={author.name}
                                        />
                                    ))
                                ) : (
                                    <Typography variant="body1">No authors available.</Typography>
                                )}
                            </FormGroup>
                        )}
                    </Grid>
                </Box>

                <Box
                    sx={{
                        position: 'fixed', bottom: BROWN_FOOTER_HEIGHT, left: 0, right: 0,
                        display: 'flex', justifyContent: 'space-around', p: 1.5,
                        borderTop: '1px solid lightgray', backgroundColor: '#fff', zIndex: 1001,
                        height: ACTION_BUTTONS_HEIGHT, boxSizing: 'border-box',
                    }}
                >
                    <Button variant="contained" color="secondary" onClick={handleReset} sx={{ flexGrow: 1, mr: 1 }} disabled={!isFilterSelected}>Reset</Button>
                    <Button variant="contained" color="primary" onClick={handleApply} sx={{ flexGrow: 1, ml: 1 }} disabled={!isFilterSelected}>Apply</Button>
                </Box>

                <Box
                    sx={{
                        position: 'fixed', bottom: 0, left: 0, right: 0,
                        height: BROWN_FOOTER_HEIGHT, backgroundColor: '#5C4033', zIndex: 1000,
                        display: 'flex', justifyContent: 'center', alignItems: 'center',
                    }}
                />
            </Box>
        </ThemeProvider>
    );
};

export default MobileBooksFilterPage;